import { downloadDiagram as downloadDiagramDiagram} from "@process-advisor/process-miner/processMiner/processMiner";

type Props = {
    mode: any;
}

export const downloadDiagram = ({ mode }: Props): any =>
    downloadDiagramDiagram(mode);
